import styled, { css } from 'styled-components'

export const SpaceDividerStyled = styled.hr<{ vertical?: boolean }>`
  margin: 0;
  ${(props) =>
    props.vertical
      ? css`
          border-left: 1px solid ${props.theme.colors.content.border};
          border-top: 0;
          border-right: 0;
          border-bottom: 0;
          align-self: stretch;
        `
      : css`
          border-top: 1px solid ${props.theme.colors.content.border};
          border-left: 0;
          border-right: 0;
          border-bottom: 0;
        `}
`
